import React from "react";
import {Button, } from "flowbite-react";
import { BsPatchCheckFill } from "react-icons/bs";

const Completed = () => {
  return (
    <>
      <div className="p-6 max-w-md text-center m-auto mt-5" style={{marginTop: '30%'}}>
      <BsPatchCheckFill style={{width: '55px', 'height': '55px', margin:'16px auto', color: '#15BE44'}}/>
        <h3 className="text-2xl mb-2 font-bold tracking-tight mb-8 text-gray-900 dark:text-white">
          Submitted for review
        </h3>
        <p className="text-sm text-gray-400 tracking-tight mt-2">
        Your application is under review. The verification process typically takes 24 hours upon submission of all requested documents. Any invalid submissions will be rejected. You will get a sms on the status of your account. If you haven't heard back from us after 24hrs, please click <span style={{color: '#dd64a5'}}><a href='https://help.rydesharing.com/hc/en-us/requests/new?ticket_form_id=12906432721689' target="_blank" rel="noreferrer"><u>here</u></a></span> to reach us. Thank you for the patience.
        </p>
        <a  href={'rydedriver://open?action=home'} onClick={()=>{window.location.href = 'rydedriver://open?action=home'}}>
        <Button
            pill={true}
            className="mt-5 m-auto w-sm"
          >
           Back to Home

          </Button>
          </a>
      
      </div>
    </>
  );
};

export default Completed;
